var _g;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgLogo(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, ["title", "titleId"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "30px",
    height: "44px",
    viewBox: "0 0 30 44",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "main-screen---version-4",
    stroke: "none",
    strokeWidth: 1,
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("g", {
    id: "main-screen",
    transform: "translate(-25.000000, -14.000000)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group",
    transform: "translate(15.000000, 12.000000)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "logo/greens",
    transform: "translate(-13.000000, 1.984112)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M52.1149751,0.804322831 C45.4038265,2.87508735 37.8705389,4.932622 29.5151122,6.9769268 L29.5007427,6.973 L29.5012245,44.0317754 L29.5012245,44.0317754 C29.5012245,43.1170203 26.1050059,42.5404275 23.6687427,42.5404275 L23.6687427,5.84042748 L23.6687427,5.84042748 C40.1652136,2.14800859 48.8793624,0.21931412 49.8111889,0.0543440841 C51.2089288,-0.19311097 53.2131084,0.465487313 52.1149751,0.804322831 Z",
    id: "Combined-Shape",
    fill: "#127475"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M29.4953213,23.4637582 C43.7168571,18.9777699 51.3054576,16.2588159 52.2611227,15.3068961 C52.2611227,15.3068961 52.2611227,18.6660565 52.2611227,19.4936666 C52.2611227,20.0253131 44.6725222,22.8887432 29.4953213,28.0839567 L29.4953213,23.4637582 Z",
    id: "Path-7",
    fill: "#0E9594"
  })))))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgLogo);
export default __webpack_public_path__ + "static/media/logo.e8b06c1a.svg";
export { ForwardRef as ReactComponent };